export const newsCategoryError = {
    requiredName: "Vui lòng nhập tên loại bài viết",
}